import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  minHeight: theme.typography.pxToRem(1000),
  padding: theme.spacing(14, 3, 14),
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  overflow: 'hidden',
  [theme.breakpoints.down('lg')]: {
    minHeight: '100vh',
    padding: theme.spacing(10, 3),
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(10, 3, 10),
  },
  '& .ESBackgroundImage': {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: -2,
  },
  '& .ESOverlay': {
    position: 'absolute',
    inset: 0,
    zIndex: -1,
    background: `linear-gradient(
      180deg,
      ${theme.palette.background.primary} 0%,
      ${theme.palette.background.primary} 20%,
      rgba(17, 17, 17, 0.85) 40%,
      rgba(17, 17, 17, 0.30) 60%,
      rgba(17, 17, 17, 0.20) 70%,
      rgba(17, 17, 17, 0.40) 80%,
      rgba(17, 17, 17, 0.70) 85%,
      ${theme.palette.background.primary} 95%,
      ${theme.palette.background.primary} 100%
    )`,
  },
  '& .ESContent': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    maxWidth: theme.typography.pxToRem(1200),
    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(60),
    },
  },
  '& .ESHeading': {
    textAlign: 'center',
    marginBottom: theme.spacing(5),
    maxWidth: theme.typography.pxToRem(634),
  },
  '& .ESParagraph': {
    textAlign: 'center',
    maxWidth: theme.typography.pxToRem(1047),
    [theme.breakpoints.down('lg')]: {
      maxWidth: theme.typography.pxToRem(640),
    },
  },
}));

export default StyledBox;
